<template>
  <div class="loading">
    <p>正在加载...</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getToken } from '@/utils/utils'

const router = useRouter()
const route = useRoute()

onMounted(() => {
  // 1. 检查是否已登录
  const token = getToken()
  if (!token) {
    router.replace('/login')
    return
  }

  // 2. 检查是否已绑定手机号
  const bindPhoneFlag = localStorage.getItem('bindPhoneV2')
  if (bindPhoneFlag !== '1') {
    // 未绑定手机号，跳转到绑定手机号页面
    router.replace('/bindPhone')
    return
  }

  // 3. 已登录且已绑定手机号，根据pageType参数进行跳转
  const pageType = route.query.pageType

  if (pageType === 'bindPhone') {
    // 跳转到绑定手机号页面（显示已绑定提示）
    router.replace('/bindPhone?status=bound')
  } else if (pageType === 'teacher') {
    // 跳转到教师页面
    router.replace('/teacher')
  } else if (pageType === 'parent') {
    // 跳转到家长页面
    router.replace('/parent')
  } else if (pageType === 'messageDetail'){
    // 跳转到学生打卡信息页面
    router.replace('/messageDetail?id=' + route.query.id)
  } else {
    // 默认跳转到家长页面
    router.replace('/parent')
  }
})
</script>

<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 16px;
  color: #666;
}
</style> 